/** Standard labels for read-only System Information fields across admin forms. */
export const SYSTEM_INFO_LABELS = {
  createdAt: 'Created at',
  createdBy: 'Created by',
  lastUpdatedAt: 'Last Updated at',
  lastUpdatedBy: 'Last Updated by',
} as const;

export const SYSTEM_INFO_SECTION_TITLE = 'System Information';

const EMPTY_VALUE = '\u2014';

export function SystemInfoBox({ label, value }: { label: string; value?: string }) {
  const display = value?.trim() ? value.trim() : EMPTY_VALUE;
  return (
    <div style={{ border: '1px solid var(--bl)', borderRadius: 'var(--rs)', padding: 12, background: 'color-mix(in srgb, var(--bg) 45%, var(--surface))' }}>
      <div style={{ fontSize: 10, color: 'var(--t3)', fontWeight: 600, marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)' }}>{display}</div>
    </div>
  );
}

export function SystemInformationSection({
  children,
  showDivider = true,
  title = SYSTEM_INFO_SECTION_TITLE,
}: {
  children: React.ReactNode;
  /** When false, omits the top border (e.g. Roles form layout). */
  showDivider?: boolean;
  title?: string;
}) {
  return (
    <div
      style={
        showDivider
          ? { marginTop: 18, borderTop: '1px solid var(--bl)', paddingTop: 14 }
          : { marginTop: 0 }
      }
    >
      <div style={{ fontSize: 11, fontWeight: 800, color: 'var(--t3)', marginBottom: 10 }}>{title}</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>{children}</div>
    </div>
  );
}
